'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { sliderTrackStyles } from './styles/slider-track.styles';
import type { SliderTrackPropsInterface } from './types/slider-track.types';

/**
 * The Slider's background bar
 *
 * @since 10.0.0
 */
export const SliderTrack = forwardRef<HTMLDivElement, SliderTrackPropsInterface>(
  (props: SliderTrackPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(sliderTrackStyles, cssProp);

    return (
      <div
        className={cx('c11n', 'c11n_slider__track', styles, className)}
        data-c11n-component="Slider.Track"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      />
    );
  },
);

SliderTrack.displayName = 'Slider.Track';
